// extracted by mini-css-extract-plugin
module.exports = {"root":"Legal_root__FeoXa","dark":"Legal_dark__qbo46","comparison":"Legal_comparison__cY6p0","legalHeaderContainer":"Legal_legalHeaderContainer__vPFAk","line":"Legal_line__JlgY_"};